import { getFunctions, httpsCallableFromURL } from 'firebase/functions';
import { app } from './firebase';
import { OnboardingData, RaceEvent } from '../types/user';

const FUNCTIONS_BASE_URL = `https://europe-west2-${process.env.REACT_APP_FIREBASE_PROJECT_ID}.cloudfunctions.net`;

export const generatePlan = async (params: {
  startDate: string;
  onboardingData: OnboardingData;
  raceEvent?: RaceEvent | null;
  isNewPlan: boolean;
}): Promise<void> => {
  console.log('[PlanService] Calling generatePlan with:', {
    start_date: params.startDate,
    is_new_plan: params.isNewPlan,
  });

  const functions = getFunctions(app, 'europe-west2');
  const callable = httpsCallableFromURL(
    functions,
    `${FUNCTIONS_BASE_URL}/runLangGenerateTrainingPlan`,
    { timeout: 540_000 }
  );

  await callable({
    start_date: params.startDate,
    onboarding_data: params.onboardingData,
    race_event: params.raceEvent ?? null,
    is_new_plan: params.isNewPlan,
  });

  console.log('[PlanService] generatePlan completed');
};
